import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import LandingPage from "@/pages/LandingPage";
import ProbeflaechePage from "@/pages/ProbeflaechePage";
import TreppenPage from "@/pages/TreppenPage";
import MikrozementPage from "@/pages/MikrozementPage";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";

// Components
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import WhatsAppButton from "@/components/WhatsAppButton";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={
            <>
              <Header />
              <main className="flex-1">
                <LandingPage />
              </main>
              <Footer />
              <CookieBanner />
              <WhatsAppButton />
            </>
          } />
          <Route path="/probeflaeche" element={
            <>
              <Header />
              <main className="flex-1">
                <ProbeflaechePage />
              </main>
              <Footer />
              <CookieBanner />
              <WhatsAppButton />
            </>
          } />
          <Route path="/treppen" element={
            <>
              <TreppenPage />
              <CookieBanner />
            </>
          } />
          <Route path="/mikrozement" element={
            <>
              <MikrozementPage />
              <CookieBanner />
            </>
          } />
          <Route path="/impressum" element={
            <>
              <Header />
              <main className="flex-1">
                <ImpressumPage />
              </main>
              <Footer />
              <CookieBanner />
              <WhatsAppButton />
            </>
          } />
          <Route path="/datenschutz" element={
            <>
              <Header />
              <main className="flex-1">
                <DatenschutzPage />
              </main>
              <Footer />
              <CookieBanner />
              <WhatsAppButton />
            </>
          } />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
